import { usePathname, useSearchParams } from 'next/navigation'
import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { SORT_DESC_SLUG, SORT_SLUG } from '../sort.constants'
import { type SortSlug } from '../sort.interface'

const useSort = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()

  const changeRouterParams = (params) => {
    router.push(`${pathname}?${params.toString()}`, undefined, { shallow: true })
  }

  const setSortValues = useCallback(
    (slug: SortSlug, value: string, desc: boolean) => {
      const params = new URLSearchParams(searchParams)
      params.set(SORT_DESC_SLUG, desc.toString())
      params.set(slug, value)
      changeRouterParams(params)
    },
    [searchParams],
  )

  const resetSort = useCallback(() => {
    const params = new URLSearchParams(searchParams)
    params.delete(SORT_SLUG)
    params.delete(SORT_DESC_SLUG)
    changeRouterParams(params)
  }, [searchParams])

  return {
    setSortValues,
    resetSort,
  }
}

export default useSort
